import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { connect } from "react-redux";
import {addGroupToCart} from '../../actions/closeLoop/addToCartActionCloseLoop'
import { addScenarioCloseLoop } from '../UserFunctions'
import PopupModal from '../PopupModal.js'
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { Alert } from "react-bootstrap";


class ScenarioPopup extends Component{
  constructor(props){
    super(props)

    this.state = {
      showpopup : false,
      status : "",
      error: ""
    }
    this.onScenarioGroupNameChange = this.onScenarioGroupNameChange.bind(this)
    this.SubmitData = this.SubmitData.bind(this)
    this.togglePopup = this.togglePopup.bind(this)
  }

  togglePopup(){
      this.setState((prevState)=>{
        return {
          ...prevState,
            status : "",
            showpopup : false
        }
      })
      if(this.state.status === 'Added Successfully') {
        this.props.useHistory.history.push(`close_loop_scenario_group`)
      }
  }

  onScenarioGroupNameChange(e){
    let obj = {
      group : e.target.value
    }
    this.props.dispatch(addGroupToCart(obj))
  }

  SubmitData(){
    console.log(this.props)
    let scenario_id = []
    let scenario_uuid = []
    let sequence = []
    this.props.items.forEach((val)=>{
      scenario_id.push(val['scenario_id'])
      scenario_uuid.push(val['scenario_uuid'])
      sequence.push(val['sequence'])
    })
    const url = (window.location.origin).concat('/close_loop_create_scenario_group')
    let uuid_name = uuidv4();
    let group_name = this.props.group +"_"+ uuid_name
    const data_for_addition ={
        scenario_group_name : group_name,
        scenario_id : scenario_id,
        scenario_uuid : scenario_uuid,
        sequence : sequence,
    }
    console.log(group_name)
    addScenarioCloseLoop(url, data_for_addition).then(res => {
        console.log("response after addition : ", res['data']['status'])
        this.setState({
            status : res['data']['status'],
            showpopup : !this.state.showpopup
        })
    })
    .catch((error) => {
      this.setState(() => {
        return {
          error: error.response.data.message,
        };
      });
    });

  }

  render(){
    return (
      <div className="CartPopup">
          <Modal isOpen={true} >
              <ModalHeader
                  toggle={this.props.closePopup}
                  style={{ color:"#524fa1" }}
              >
                Items Added
              </ModalHeader>
              <ModalBody>
              <div className="card">
                {this.state.error ? (
                  <Alert key="danger" variant="danger">
                    {this.state.error}
                  </Alert>
                ) : undefined}
                <div className="card-body">
                 {this.props.count === 0 ? <p>Cart is Empty</p>:
                  <div className="form-group">
                  Scenario Group : <input type="text" className="form-control" list="data" value={this.props.group} onChange={this.onScenarioGroupNameChange}/>
                  <table>
                    <thead>
                        <tr>
                        <th scope="col"><label htmlFor="group_name" className="col-form-label" style={{ color: "#464646"}} >Scenario Id</label></th>
                        <th scope="col"><label htmlFor="group_name" className="col-form-label" style={{ color: "#464646"}} >Scenario UUID </label></th>
                        <th scope="col"><label htmlFor="group_name" className="col-form-label" style={{ color: "#464646"}} >Sequence</label></th>
                        </tr>
                     </thead>
                    <tbody>
                        {
                          this.props.items.map((val,index)=>{
                            return (

                              <tr key={index}>
                                <td>
                                <input style={{width:"70%"}} type="text" className="form-control col-lg-2 scene_id" id={"scenario_id"+index} value={val['scenario_id']}/>
                                </td>
                                <td>
                                     <input type="text" className="form-control scene_uuid" id={"scenario_uuid"+index} value={val['scenario_uuid']}/>
                                </td>
                                <td>
                                     <input style={{width:"70%"}} type="text" className="form-control sequence" id={"seq"+index} value={val['sequence']}/>
                                </td>
                              </tr>
                            )
                          })
                        }
                    </tbody>
                  </table>
                  </div>

                 }
                </div>
              </div>

              </ModalBody>
              <ModalFooter>
                {this.props.count === 0 ?
                <p></p>
                :
                <Button color="" className="btn btn-primary" onClick={this.SubmitData}>Add To Scenario Group</Button>}
                </ModalFooter>
            </Modal>
            {this.state.showpopup ? <PopupModal text={this.state.status} closePopup={this.togglePopup.bind(this)} />: ""}
      </div>
    )
  }
}

ScenarioPopup.defaultProps = {
  useHistory : {history : []}
}
ScenarioPopup.propTypes={
useHistory:PropTypes.string,
dispatch:PropTypes.string,
items:PropTypes.string,
group:PropTypes.string,
closePopup:PropTypes.string,
count:PropTypes.string,
}
ScenarioPopup.defaultProps= {
useHistory:[],
dispatch:[],
items:[],
group:[],
closePopup:[],
count:[],
}

const mapStateToProps = (state) => {
    return {
        count : state.cartItems.count,
        items : state.cartItems.items,
        group: state.cartItems.group,
    }
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }

// onSubmit = (e) => {
//     e.preventDefault();
//     const submitValue = {
//         scenario_id: this.state.scenario_id,
//         scenario_group_name: this.state.scenario_group_name,
//         scenario_uuid: this.state.scenario_uuid,
//         scenario_name: this.state.scenario_name,
//         scenario_group_scenario_mapping_id: this.props.content.scenario_group_scenario_mapping_id,
//         sequence: this.props.content.sequence,
//         scenario_group_id: this.props.content.scenario_group_id
//     }
//     //console.log(this.state);
// //        updateScenarioGroupDetails(submitValue).then( (response)=> {
// //            console.log(response);
// //        })

//     const edit_api_url = (window.location.origin).concat('/edit')
//     const data_for_api = {
//         scenario_uuid : submitValue['scenario_uuid'],
//         scenario_description : submitValue['scenario_name']
//     }
//     editDb(edit_api_url, data_for_api).then(res => {
//         console.log("Status of updation : ", res['data']['status'])
//         if(res['data']['status'] === "Updated Successfully"){
//             this.props.dispatch(editScenarioGroupData(submitValue));
//             this.props.handleEditModalClose();
//         }

//     })

//     //this.props.dispatch(editScenarioGroupData(submitValue));
//     //this.props.handleEditModalClose();
// };


export default connect(mapStateToProps)(ScenarioPopup)
